import { observer } from 'decorators';
import { makeStyles } from 'hooks';
import { Grid, Typography } from '@material-ui/core';
import NavLink from '../navLink';
import router from 'services/router';

import Chevron from 'mdi-material-ui/ChevronRight';

const useStyles = makeStyles(theme => ({
  link: {
    color: 'inherit'
  }
}));

export default observer(function BreadCrumbs({ items }) {
  const classes = useStyles();

  if (!items || !items.length) { return null; }

  const routes = router.navRouteData;
  return <Grid component="nav" container spacing={1} alignItems="center" aria-label="Quick Links">
    <Grid item>
      <NavLink name="home" classes={{ link: classes.link }}>Home</NavLink>
    </Grid>
    {
      items.map((v, i) => {
        const route = routes.find(r => r.name === v.name);
        if (!route || route.name === 'home') { return null; }

        const { className, ...other } = v;
        return [
          <Grid item key={v.name}>
            <Chevron key={'fa_' + v.name} />
          </Grid>,
          <Grid item key={'item_' + v.name}>
            {(i === items.length - 1) ?
              <Typography color="inherit" variant="body2">{route.title}</Typography>
              :
              <NavLink {...other} classes={{ link: classes.link }}>{route.title}</NavLink>
            }
          </Grid>
        ];
      })
    }
  </Grid>;
});